/* generated by tpl.py, DO NOT edit */
/* jshint -W004 */
/* jshint -W053 */
/* global exports */
/* exported tpl__toast */
function tpl__toast() {
    return '<div><div class="mi-detail__dislike-tip" style="display:none"><span></span></div><div class="mi-detail__text-toast" style="display: none"></div></div>';
}

exports.tpl__toast = tpl__toast;
